import CryptoJS from 'crypto-js'
import utils from '@/utils/utils'

// 十六位十六进制数作为密钥
const key = CryptoJS.enc.Utf8.parse('451fd155751978ae')
// 十六位十六进制数作为密钥偏移量
const iv = CryptoJS.enc.Utf8.parse('03298f926df0e295')
const secret = {
}
/** 加密文本 */
secret.encryptionText = function (word) {
  let srcs = CryptoJS.enc.Utf8.parse(word)
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.ciphertext.toString().toUpperCase()
}



/** 解密文本 */
secret.decryptText = function (word) {
  if (utils.isNotEmpty(word)) {
    let encryptedHexStr = CryptoJS.enc.Hex.parse(word)
    let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
    let decrypt = CryptoJS.AES.decrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
    return decryptedStr.toString()
  } else {
    return ''
  }
}

    /** 登录密码加密 */
secret.loginPwdEncrypt = function(pw){
      console.log('pw',pw)
      const data = CryptoJS.enc.Utf8.parse(pw);
      const key = CryptoJS.enc.Utf8.parse('XT0323AES128WORD');
      let encryptPwd  = CryptoJS.AES.encrypt(data, key, {
          mode    : CryptoJS.mode.ECB,
          padding : CryptoJS.pad.Pkcs7
      }).toString();
      return encryptPwd
  }

/*** 曹文妍添加 */

/** 加密文本 */
secret.encrypt= function (word, keyStr, ivStr) {
  let key = key
  let iv = iv

  if (keyStr) {
      key = CryptoJS.enc.Utf8.parse(keyStr);
      iv = CryptoJS.enc.Utf8.parse(ivStr);
  }

  let srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
  });
  // console.log("-=-=-=-", encrypted.ciphertext)
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}


/** 解密文本 */
secret.decrypt = function (str, keyStr, ivStr) {
  let key = key;
  let iv = iv;

  if (keyStr && ivStr) {
      key = CryptoJS.enc.Utf8.parse(keyStr);
      iv = CryptoJS.enc.Utf8.parse(ivStr);
  }

  let base64 = CryptoJS.enc.Base64.parse(str);
  let src = CryptoJS.enc.Base64.stringify(base64);

  var decrypt = CryptoJS.AES.decrypt(src, key, {
      iv: iv,
      // mode: CryptoJS.mode.ECB, 
      mode: CryptoJS.mode.BCB, // 保持一致
      padding: CryptoJS.pad.Pkcs7
  });

  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

export default secret



// WEBPACK FOOTER //
// ./src/utils/secret.js